/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _4 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>4 - React.lazy версии 16.6+</h2>
    <p className={styles.description}>
      Официальный API который позволяет рендерить динамически загружаемый компонент. Заменит{' '}
      <code className={styles.code}>react-loadable</code>.
    </p>
    <CopyBlock text={`React.lazy(loader);`} language="javascript" showLineNumbers={false} theme={ocean} />
    <p className={styles.description}>
      Принимает функцию-згарузчик которая возвращает результат динамического импорта - промис, значение которого будет
      дефолтный экспорт модуля, реакт компонент.{' '}
    </p>
    <CopyBlock
      text={`import React, { lazy, Suspense } from 'react';

const AsyncComponent = lazy(() => import('./AsyncComponent'));

const MyComponent = () => (
  <Suspense fallback={<div>Loading...</div>}>
    <AsyncComponent />
  </Suspense>
);`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <p className={styles.description}>
      Если во время ренедера <code className={styles.code}>MyComponent</code>, компонент{' '}
      <code className={styles.code}>AsyncComponent</code> еще не загружен, необходимо показать фолбек. Для этого
      используется компонент <code className={styles.code}>Suspense</code>. Проп{' '}
      <code className={styles.code}>fallback</code> принимает любой React-элемент.{' '}
      <code className={styles.code}>Suspense</code> можно поместить в любом месте над асинхронным компонентом, даже
      оборачивая целую группу.{' '}
    </p>
    <a
      className={styles.link}
      href="https://reactjs.org/docs/code-splitting.html#reactlazy"
      target="_blank"
      rel="noopener noreferrer"
    >
      Документация React.lazy
    </a>
  </section>
))
